import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const DashboardCard = ({ title, value, subtitle, icon: Icon, color = 'military' }) => {
  const { getThemeClasses } = useTheme();
  const themeClasses = getThemeClasses();
  const colorClasses = {
    military: 'from-military-600 to-military-700',
    blue: 'from-blue-600 to-blue-700',
    green: 'from-green-600 to-green-700',
    emerald: 'from-emerald-600 to-emerald-700',
    amber: 'from-amber-600 to-amber-700',
    red: 'from-red-600 to-red-700',
    purple: 'from-purple-600 to-purple-700',
  };

  const hoverBorderClasses = {
    military: 'hover:border-military-500/50',
    blue: 'hover:border-blue-500/50',
    green: 'hover:border-green-500/50',
    emerald: 'hover:border-emerald-500/50',
    amber: 'hover:border-amber-500/50',
    red: 'hover:border-red-500/50',
    purple: 'hover:border-purple-500/50',
  };

  return (
    <div className={`${themeClasses.dashboardCard} border ${themeClasses.border} rounded-xl p-3 sm:p-4 lg:p-6 ${themeClasses.dashboardCardHover} ${hoverBorderClasses[color]} transform transition-all duration-200 cursor-pointer min-w-0`}>
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <p className={`${themeClasses.textMuted} text-xs sm:text-sm font-medium mb-1 sm:mb-2 truncate`}>{title}</p>
          <h3 className={`text-xl sm:text-2xl lg:text-3xl font-bold ${themeClasses.textPrimary} mb-1`}>{value}</h3>
          {subtitle && <p className={`${themeClasses.textMuted} text-xs truncate`}>{subtitle}</p>}
        </div>
        {Icon && (
          <div className={`bg-gradient-to-br ${colorClasses[color]} p-2 sm:p-2.5 lg:p-3 rounded-lg shadow-md flex-shrink-0`}>
            <Icon size={18} className="text-white sm:w-5 sm:h-5 lg:w-6 lg:h-6" />
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardCard;
